export const UPDATE_PASSWORD_MUTATION = `
  mutation UpdatePasswordMutation($input: updatePasswordInput!) {
    public {
      updatePassword(input: $input) {
        id
      }
    }
  }
`;
